(function($){

	$.fn.getContent = function(options){

		var settings = $.extend({
			template : "",
			endpoint: ""
		}, options );
		var that = this;
		var template = null;
		var nextUrl = settings.endpoint;
		var loading=false;

		this.insert = function(res) {
			$(that).append(template({
				items:res.results
			}));
		};

		this.getItems = function() {
			$.ajax({
				type: 'GET',
				url: nextUrl,
				success: function(res) {
					loading=false;
					that.insert(res);
					console.log(res);
					nextUrl = res['next'];
					console.log(nextUrl);
					enqueueImgs();
					$("#loadMore").attr("disabled", false);
				},
				error: function(err) {
					console.log(err);
				}
			});
		};
		this.render = function() {
			console.log(loading);
			if(loading==true){
				this.request.abort()
			}
			loading = true;
			if (template) {
				that.getItems();
			} else {
				this.request = $.ajax({
					type: 'GET',
					url: settings.template,
					beforeSend: function(){
						console.log('here');
					},
					success: function(res) {
						template = Handlebars.compile(res)
						that.getItems();
					},
					error: function(err) {
						console.log(err);
					}
				});
			};
		};

		this.loadMore = function() {
			$("#loadMore").unbind()
			$("#loadMore").on('click', function() {
				console.log(nextUrl);
				$("#loadMore").attr("disabled", true);
	    		if (nextUrl != null) {
	    			that.render();
	    		}
	    	});
		};


		if ($(this).length) {
			this.render();
			this.loadMore();
		}

		return this;
	}

}( jQuery ));
function computeHash(){
	// Function which aims to get relevant URL for API and Hash
	var categories = $('.js-category-filter:checked')
		.map(function(){return $(this).data('categoryId')})
		.get()
	var empty_category = false;

	if(categories.length==0){
		categories=$('.js-category-filter')
			.map(function(){return $(this).data('categoryId')})
			.get();
		empty_category=true
	}

	var selectedCategories = $('.js-category-filter:checked')
		.map(function () {
			return {
				name: $(this).data('category-name'),
				id: $(this).data('category-id')
			};
		})
		.get();

	var selectedCategoriesList = $('#selectedCategoriesList');

	selectedCategoriesList.empty(); // Clear the list

	selectedCategories.forEach(function(category) {
		var listItem = $('<li class="relative rounded-full bg-gray-100 text-body text-gray-900 px-3 py-1 truncate">').text(category.name).attr('id', category.id);
		var removeLink = $('<a href="#" class="ml-2 text-gray-900 remove-category stretched-link ">' +
			'<svg class="w-3 h-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14"><path fill="#2A2A3C" d="M12.9563 12.2938C13.0023 12.3367 13.0393 12.3884 13.0649 12.4459C13.0905 12.5034 13.1043 12.5655 13.1054 12.6284C13.1065 12.6914 13.0949 12.7539 13.0714 12.8123C13.0478 12.8706 13.0127 12.9237 12.9682 12.9682C12.9237 13.0127 12.8706 13.0478 12.8123 13.0714C12.7539 13.0949 12.6914 13.1065 12.6284 13.1054C12.5655 13.1043 12.5034 13.0905 12.4459 13.0649C12.3884 13.0393 12.3367 13.0023 12.2938 12.9563L7.00003 7.66331L1.70628 12.9563C1.61742 13.0391 1.49989 13.0842 1.37845 13.082C1.25701 13.0799 1.14115 13.0307 1.05526 12.9448C0.969379 12.8589 0.920184 12.743 0.918042 12.6216C0.915899 12.5002 0.960976 12.3826 1.04378 12.2938L6.33674 7.00003L1.04378 1.70628C0.960976 1.61742 0.915899 1.49989 0.918042 1.37845C0.920184 1.25701 0.969379 1.14115 1.05526 1.05526C1.14115 0.969379 1.25701 0.920184 1.37845 0.918042C1.49989 0.915899 1.61742 0.960976 1.70628 1.04378L7.00003 6.33674L12.2938 1.04378C12.3826 0.960976 12.5002 0.915899 12.6216 0.918042C12.743 0.920184 12.8589 0.969379 12.9448 1.05526C13.0307 1.14115 13.0799 1.25701 13.082 1.37845C13.0842 1.49989 13.0391 1.61742 12.9563 1.70628L7.66331 7.00003L12.9563 12.2938Z"/></svg></a>');
			removeLink.on('click', function () {
			$('.js-category-filter[data-category-id=' + category.id + ']').prop('checked', false);
			computeHash();
		});
		listItem.append(removeLink);
		selectedCategoriesList.append(listItem); // Add the item to the list
	});

	var price_order =$('.js-order-by-price').val();
	if (price_order == "1"){
		order = "";
	} else if (price_order == "-1"){
		order = "-";
	} else {
		order = null
	}
	//
	// // encodeURIComponent
	var url_obj = {
			// ordering:order+'_price'

	}
	if(order!=null){
		url_obj.ordering=order+'_price'
	}
	if (categories.length>0){
		url_obj.categories=categories
	}
	var params = "&"+$.param(url_obj, true)
	$('#js-productList').empty();
	$('#js-productList').getContent({
		template: staticUrl + "v2/templates/products.html",
		endpoint: "/api/products/?structure__in=parent,standalone" + params
	});

	if (empty_category==true){
		delete url_obj.categories
	}

	window.location.hash=$.param(url_obj, true)
}

function decodeHash(){
	var _arr = window.location.hash?(window.location.hash.split('#')[1].split('&')).map(function(x){return x.split('=')}):null;
	if (_arr==null){
		return false;
	}
	var res = _arr.reduce(function(x,y){
    	var key=y[0],
    		value=y[1];

    	if (key in x){
    		merge = x[key].length
    		if(x[key].length>1){
    			x[key].push(value)
    		}else{
    			x[key]=[x[key], value]
    		}
    	}else{
    		x[key]=value
    	}
    	return x
	},{});
	if('ordering' in res){
		res.ordering=res.ordering=='_price'?1:-1
	}else{
		res.ordering = 0
	}
	$('.js-order-by-price').val(res.ordering).trigger('change')

	if('categories' in res){
		if (res.categories.length==1){
				$('#js-category-filter-'+res.categories).prop('checked', true)

		}else{
			res.categories.map(function(x){
				$('#js-category-filter-'+x).prop('checked', true)
			})

		}
	};
	return res
}

$(function(){
	decodeHash();
	computeHash();

	// window.onhashchange = function(){computeHash()};
	// $(window).trigger('hashchange')
	$('.js-category-filter').on('change',computeHash)
	$('.js-order-by-price').on('change',computeHash)

});
